import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveBar } from 'cccisd-nivo/bar';
import { round, mean } from 'lodash';

const OverallKeyElementChart = props => {
    const { data, subscales, groupLevelMap } = props;

    const getData = d => {
        const rows = [];

        for (var group of Object.keys(groupLevelMap)) {
            const sites = [];
            for (var siteCandidate of d.groups.siteList) {
                if (groupLevelMap[group].includes(siteCandidate.group.groupId)) {
                    sites.push(siteCandidate);
                }
            }
            if (!sites.length) {
                continue;
            }

            const overallSubscaleAverages = [];
            const keySubscaleAverages = [];

            for (var subscale of subscales) {
                const subscaleScores = [];
                for (var site of sites) {
                    for (var item of subscale.items) {
                        const score = site.descendantRoles.youthSummary[item];
                        if (score !== null) {
                            subscaleScores.push(score);
                        }
                    }
                }

                if (subscaleScores.length) {
                    const subscaleAvg = mean(subscaleScores);
                    overallSubscaleAverages.push(subscaleAvg);
                    if (subscale.keyElement) {
                        keySubscaleAverages.push(subscaleAvg);
                    }
                }
            }

            rows.push({
                group,
                overall: overallSubscaleAverages.length ? mean(overallSubscaleAverages) : null,
                keyElements: keySubscaleAverages.length ? mean(keySubscaleAverages) : null,
            });
        }

        let totalScore = 0;
        let totalKeyElements = 0;
        const nullScores = {};
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            if (row.overall === null) {
                if (!nullScores.overall) {
                    nullScores.overall = [];
                }
                nullScores.overall.push(i);
            } else {
                totalScore += row.overall;
            }
            if (row.keyElements === null) {
                if (!nullScores.keyElements) {
                    nullScores.keyElements = [];
                }
                nullScores.keyElements.push(i);
            } else {
                totalKeyElements += row.keyElements;
            }
        }
        const numNullOverall = nullScores.overall ? nullScores.overall.length : 0;
        const numNullKeyElm = nullScores.keyElements ? nullScores.keyElements.length : 0;
        return [
            {
                group: 'Overall TOM 2.0 Score',
                average:
                    rows.length === numNullOverall ? 0 : round((totalScore / (rows.length - numNullOverall)) * 100, 2),
            },
            {
                group: 'Key Elements Score',
                average:
                    rows.length === numNullKeyElm
                        ? 0
                        : round((totalKeyElements / (rows.length - numNullKeyElm)) * 100, 2),
            },
        ];
    };

    const chartData = getData(data);

    if (!chartData.length > 0) {
        return (
            <div style={{ width: '770px', height: '300px', textAlign: 'center' }}>
                <h2 style={{ marginTop: '125px' }}>No data</h2>
            </div>
        );
    }

    const longestLabel = Math.max(
        ...chartData.map(o => {
            return o.group.length;
        })
    );

    return (
        <div style={{ width: '770px', height: `${300 + 6.5 * longestLabel}px` }}>
            <ResponsiveBar
                indexBy="group"
                maxValue={100}
                labelFormat={d => <tspan y={-8}>{d}</tspan>}
                labelSkipWidth={0}
                labelSkipHeight={1}
                keys={['average']}
                theme={{ fontSize: 16 }}
                axisBottom={{ tickRotation: 45 }}
                data={chartData}
                margin={{ top: 15, right: 150, bottom: 6.5 * longestLabel, left: 50 }}
            />
        </div>
    );
};

OverallKeyElementChart.propTypes = {
    data: PropTypes.object,
    subscales: PropTypes.array,
    groupLevelMap: PropTypes.object,
    hiddenChart: PropTypes.func,
};

export default OverallKeyElementChart;
